import { Box, Button, Typography } from '@mui/material'

import { THEMES } from '@/constants'
import useTheme from '@/hooks/useTheme'

export interface UpgradeWithScreenshotProps {
  titleLabel: string
  descriptionLabel: string
  buttonLabel: string
  viewPricingLabel: string
  screenshotName: string
  onUpgradeClick: () => void
  canManageBilling?: boolean
}

const UpgradeWithScreenshot: React.FC<UpgradeWithScreenshotProps> = ({
  titleLabel,
  descriptionLabel,
  buttonLabel,
  viewPricingLabel,
  screenshotName,
  onUpgradeClick,
  canManageBilling = false,
}) => {
  const { theme } = useTheme()
  const darkMode = theme === THEMES.DARK
  const variant = darkMode ? 'Dark' : 'Light'

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: theme => theme.spacing(8),
        textAlign: 'center',
      }}
    >
      <Typography variant="h5" gutterBottom>
        {titleLabel}
      </Typography>
      <Typography variant="body1" sx={{ mb: theme => theme.spacing(4) }}>
        {descriptionLabel}
      </Typography>
      <Button
        variant="contained"
        color="info"
        size="large"
        onClick={onUpgradeClick}
        sx={{
          color: 'white',
        }}
      >
        {canManageBilling ? buttonLabel : viewPricingLabel}
      </Button>
      <Box
        component="img"
        src={`/static/img/screenshots/${screenshotName}-${variant}.webp`}
        alt={`${screenshotName} Dashboard Screenshot`}
        sx={{
          maxWidth: '80%',
          height: 'auto',
          borderRadius: theme => theme.spacing(1),
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          mt: theme => theme.spacing(4),
        }}
      />
    </Box>
  )
}

export default UpgradeWithScreenshot
